<template>
    <div>
        <Modal v-model="visible" width="600px" title="可用控件编码" :footer-hide="true" :mask-closable="false" class="my-modal">
            <div class="table-box">
                <Table :columns="columns" :data="tableData" :maxHeight="tableH">
                    <!-- 编码 -->
                    <template slot-scope="{ row }" slot="componentKey">
                        <span>{{ row.componentKey }}</span>
                        <a class="copy-btn" @click="$units.copyUrl(row.componentKey)">复制</a>
                    </template>

                    <!-- 含义 -->
                    <template slot-scope="{ row }" slot="componentName">
                        <span>{{ row.componentName }}</span>
                        <a class="copy-btn" @click="$units.copyUrl(row.componentName)">复制</a>
                    </template>
                </Table>
            </div>
        </Modal>
    </div>
</template>

<script>
export default {
    components: {},
    props: [],
    data() {
        return {
            visible: false,
            loading: false,
            tableData: [],
            tableH: document.body.clientHeight - 260,
            columns: [
                {
                    title: '编码',
                    align: 'center',
                    tooltip: true,
                    // key: 'componentKey',
                    slot: 'componentKey'
                },
                {
                    title: '含义',
                    align: 'center',
                    tooltip: true,
                    // key: 'componentName',
                    slot: 'componentName'
                }
            ]
        };
    },
    created() {
        window.addEventListener('resize', () => {
            this.tableH = document.body.clientHeight - 260;
        });
    },
    methods: {
        open() {
            this.visible = true;
            this.getList();
        },
        getList() {
            this.$http({
                url: '/buz/eSignComponent/read/list',
                type: 'GET',
                data: {}
            }).then(res => {
                this.tableData = res.data;
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.my-modal /deep/ .ivu-modal-body {
    padding-bottom: 0;
}
.table-box {
    padding: 20px 0;
}
.copy-btn {
    margin-left: 15px;
}
</style>
